export const Constants = Object.freeze({
  NESTED_QUOTA_LIMIT: 4,
  UNICORN_NESTING_TOOLTIP: {
    HIGHLY_CHALLENGING_QUOTA:
      'This has been flagged as a highly challenging quota. Please consider adjusting quotas or targeting to broaden your search.',
  },
  NESTING_TITLE_REGEX: '^[a-zA-Z0-9 !%&*(){}\\[\\]|\\\\/<>+=\\-_.]+$', // Allowed characters
});
